import { createVisitor } from "../api/createVisitor";
import { createSession, getSession } from "../utils/getSession";

export const trackSession = () => {
  const sessionId = getSession();
  if (!sessionId) {
    createVisitor().then((res) => createSession(res.id));
  }
};
